module.exports = __webpack_public_path__ + "static/StudioPro-Regular-e57d2a294a7e9fd025a8f44753d2521e.woff2";